import { FalconContext } from '@b2c/services/auth';
import { createContext } from 'react';

export const SecureContextInfoContext =
  createContext<FalconContext.SecurityContextEstablishResult>(null);
